export enum ResourceSuggestionOption {
  auto = 1,
  suggestion,
}
